import { Song } from 'types/Audio';

export type NewSong = {
  id: string;
  audio_url: string;
  cover_url: string;
  title: string;
  duration: string;
  is_paid: boolean;
  artist: string;
};

export const mapToOldFormatSong = ({
  id,
  audio_url,
  title,
  duration,
  is_paid,
  artist,
  cover_url
}: NewSong) => ({
  id,
  url: audio_url,
  songName: title,
  duration,
  isPaid: is_paid,
  artistName: artist,
  cover_url
});

// We do this hardcode because we can't change it in CMS, because mobile uses it also
export const combineSongsCategories = (song: Song): Song => {
  let artistName = song.artistName;

  if (artistName === 'HipHop') {
    artistName = 'Hip Hop';
  }

  if (artistName === 'CInematic') {
    artistName = 'Cinematic';
  }

  return {
    ...song,
    artistName
  };
};

// we should call it on user interaction, it won't work otherwise
export const enableSound = (element: HTMLMediaElement): void => {
  // setting muted to true doesn't help, so we toggle the attribute
  element.muted = true;
  element.muted; // we do read-operation to make browser apply changes
  element.muted = false;
};
